import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { Input } from '@components/core-ui/form-elements/Input';
import EmailIcon from '@components/icons/Email.svg';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { normalizeEmail } from '@helpers/normalizeEmail';
import { useAPI } from '@providers/useAPI';
import { useMutation } from '@tanstack/react-query';
import { AdminService } from 'app/API';
import { notifyApiCallError } from 'app/http/notifyApiCallError';
import React, { useState } from 'react';

import { Content } from './styles/Content';

type TProps = {
  onCancel: () => void;
  onSuccess: () => void;
  id: string;
  email: string;
};

export const AdminEditUserEmailModal = ({ onCancel, onSuccess, id, email }: TProps) => {
  const { call } = useAPI();
  const [newEmail, setNewEmail] = useState(email);

  const updateMutation = useMutation({
    mutationFn: () =>
      call(() => AdminService.updateUserEmail({ userId: id, requestBody: { email: normalizeEmail(newEmail) } })),
    onSuccess: () => onSuccess(),
    onError: notifyApiCallError,
  });

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    updateMutation.mutate();
  };

  return (
    <ModalWrapper width="300px">
      <ModalTitle>Edit User Email</ModalTitle>
      <Content>
        <form action="#" onSubmit={submit}>
          <div className="inputWrapper">
            <Input
              icon={EmailIcon}
              required
              value={newEmail}
              type="email"
              label="Email"
              name="email"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setNewEmail(e.target.value)}
              error={updateMutation.isPending && !newEmail}
            />
          </div>
          <div className="buttonWrapper">
            <OutlinedButton onClick={onCancel}>Cancel</OutlinedButton>
            <Button type="submit" disabled={updateMutation.isPending || !newEmail.length}>
              Save
            </Button>
          </div>
        </form>
      </Content>
    </ModalWrapper>
  );
};
